import api from './axiosInstance';

export const getDocumentUsageStats = {
  getStats: async () => {
    try {
      const response = await api.get(`/document-usage/stats`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      error.customMessage =
        'No se pudo obtener la información solicitada. Intenta nuevamente.';
      throw error;
    }
  },
};

export const getDocumentUsageReport = {
  getReport: async () => {
    try {
      const response = await api.get(`/document-usage/report`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      error.customMessage =
        'No se pudo obtener la información solicitada. Intenta nuevamente.';
      throw error;
    }
  },
};

export const getDocumentUsageByService = {
  getByService: async () => {
    try {
      const response = await api.get(`/document-usage/by-service`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response.data.map((item) => ({
        name: item.service,
        amount: item.totalUses,
        percentage: item.percentage,
      }));
    } catch (error) {
      error.customMessage =
        'No se pudo obtener el uso por servicio. Intenta nuevamente.';
      throw error;
    }
  },
};

export const getDocumentUsageByArea = {
  getByArea: async () => {
    try {
      const response = await api.get(`/document-usage/by-area`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response.data.map((item) => ({
        name: item.area,
        amount: item.totalUses,
        percentage: item.percentage,
      }));
    } catch (error) {
      error.customMessage =
        'No se pudo obtener el uso por área. Intenta nuevamente.';
      throw error;
    }
  },
};

export const getDocumentUsageByUser = {
  getByUser: async () => {
    try {
      const response = await api.get(`/document-usage/by-user`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response.data.map((item) => ({
        name: item.user,
        amount: item.totalUses,
        percentage: item.percentage,
      }));
    } catch (error) {
      error.customMessage =
        'No se pudo obtener el uso por usuario. Intenta nuevamente.';
      throw error;
    }
  },
};
